import { render, staticRenderFns } from "./GridNavigationItem.vue?vue&type=template&id=7722d8d4&scoped=true&"
import script from "./GridNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./GridNavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./GridNavigationItem.vue?vue&type=style&index=0&id=7722d8d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7722d8d4",
  null
  
)

export default component.exports